import {
  // Logos
  ucsc,
  udemy,
  prodigi_interactive,
  isaca_ucsc,
  huawei,
  reidcon_ucsc,
  ieee_ucsc,

  // Certifications
  huawei_training,
  prodigi_beat_covid,
  ucsc_isaca_freshhack,
  udemy_ue_dynamic_sky,
} from "src/assets";

// Certification Data
export const CERTIFICATIONS = [
  {
    id: 1,
    title: "Unreal Engine 5: One Course Solution For Dynamic Sky System",
    issuer: "Vince Petrelli on Udemy",
    issueDate: "Nov 2024",
    logo: udemy,
    certificateImg: udemy_ue_dynamic_sky,
    description:
      "Successfully completed the course on Udemy as taught by Vince Petrelli. The certificate indicates the entire course was completed as validated by the student.",
  },
  {
    id: 2,
    title: "Faculty Award for Best Performing Students and the Director’s List",
    issuer: "University of Colombo School of Computing",
    issueDate: "May 2023",
    logo: ucsc,
    certificateImg: null,
    description:
      "Honored to be selected as a Best Performing Student and included in the Director's List for the Academic Year 19 [June 2022 - May 2023].",
  },
  {
    id: 3,
    title: `"Beat the Covid-19" Game Challenge 2020 - Finalist`,
    issuer: "Prodigi Interactive",
    issueDate: "Apr 2020",
    logo: prodigi_interactive,
    certificateImg: prodigi_beat_covid,
    description:
      "Finalist in the first online game jam in Sri Lanka, conducted from April 8th to April 12th, 2020.",
  },
  {
    id: 4,
    title: "FreshHack 1.0",
    issuer: "UCSC ISACA Student Group",
    issueDate: "2020",
    logo: isaca_ucsc,
    certificateImg: ucsc_isaca_freshhack,
    description:
      "Awarded a certificate of achievement as part of team fSociety at FreshHack 1.0, organized by UCSC ISACA Student Group.",
  },
  {
    id: 5,
    title: "HUAWEI Training – The Future of Mobile App Industry",
    issuer: "HUAWEI",
    issueDate: "2020",
    logo: huawei,
    certificateImg: huawei_training,
    description:
      "Received a participation certificate for successfully attending and actively engaging in the webinar series.",
  },
  {
    id: 6,
    title: "ReidCon - Finalist",
    issuer: "ReidCon of UCSC",
    issueDate: "2020",
    logo: reidcon_ucsc,
    certificateImg: null,
    description:
      "Selected as a finalist at ReidCon of UCSC and proceeded to the exhibition phase for the Rise of Rage online multiplayer game.",
  },
  {
    id: 7,
    title: "ReidXtream - Finalist",
    issuer: "IEEE Student Branch of UCSC",
    issueDate: "2020",
    logo: ieee_ucsc,
    certificateImg: null,
    description:
      "Finalist as part of team GameOfCodes at ReidXtream 1.0, organized by the IEEE Student Branch of UCSC.",
  },
];
